import SelectItemModal from 'template/Modals/SelectItem';
import getTeacherStatus from 'controllers/teacher/getTeacherStatus'
import getStudentClass from 'controllers/student/getStudentClass'

//
// User can select a class.
// a wraper of SelectItemModal
//
// eg.
// SelectClass({ schoolId })
//  .then()
//  .catch()
//
export default function(opts) {
  const {
    schoolId,
    Id,
    state,
  } = opts;

  // this will return a promise
  if(state == 'teacher'){
    return SelectItemModal({
      headerTitle: __('Select Class', 'schedule'),
      headerIcon: 'fa icon-users',
      itemName: __('Class', 'schedule'),
      searchPlaceholder: __('Search Class', 'schedule'),

      getItemLabel: (item)=>{
        return item.ctClass__cName;
      },
      fetchItems: (cb)=>{
        getTeacherStatus(Id, 'all')
        .then((data)=>{
          cb(data.class_list);
        })
        .catch((err)=>{ console.error(err); });
      },

      ...opts,

    })
  } else if (state == 'student'){
    return SelectItemModal({
      headerTitle: __('Select Class', 'schedule'),
      headerIcon: 'fa icon-users',
      itemName: __('Class', 'schedule'),
      searchPlaceholder: __('Search Class', 'schedule'),

      getItemLabel: (item)=>{
        return item.className;
      },
      fetchItems: (cb)=>{
        getStudentClass(Id, 'all')
        .then((data)=>{
          cb(data.classList);
        })
        .catch((err)=>{ console.error(err); });
      },

      ...opts,

    })
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/SelectAttendanceClass/index.js